<template>
  <vuex-table :auto_start="false" :fields="fields" table_store="call-tracking/stats/table" />
</template>

<script>
  export default {
    computed: {
      fields: function() {
        return [
          {
            key: 'number',
            label: this.$t('call-tracking.number.field.number'),
            sortable: true,
            class: 'w-25'
          },
          {
            key: 'client_id',
            label: this.$t('call-tracking.number.field.client_id'),
            sortable: true,
            class: 'w-25'
          },

          {
            key: 'caller_number',
            label: this.$t('call-tracking.number.field.caller_number'),
            class: 'w-25',
            sortable: true
          },

          {
            key: 'called_at',
            label: this.$t('call-tracking.number.field.call_date'),
            class: 'w-25',
            sortable: true
          }
        ];
      }
    }
  };
</script>
